import { render, staticRenderFns } from "./solutionDetails1.vue?vue&type=template&id=59bd0e64&scoped=true&"
import script from "./solutionDetails1.vue?vue&type=script&lang=js&"
export * from "./solutionDetails1.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails1.vue?vue&type=style&index=0&id=59bd0e64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd0e64",
  null
  
)

export default component.exports